module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat2@3x-6d95af5fea701524fc6dcc0766cb09e9.jpg";